import React from 'react';
import { getStatusMeta } from '../../constants/appMeta';

/** Chấm màu + nhãn trạng thái của ứng dụng (đang chạy / thử nghiệm / ...). */
const StatusBadge = ({ status, className = '' }) => {
    const meta = getStatusMeta(status);
    return (
        <span
            className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-medium ${meta.badge} ${className}`}
        >
            <span className={`w-1.5 h-1.5 rounded-full ${meta.dot}`} />
            {meta.label}
        </span>
    );
};

export default StatusBadge;
